import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import "./cart.css"; // ✅ new file

function Cart() {
  const { cart, addToCart, removeFromCart, clearFromCart } = useContext(CartContext);
  const navigate = useNavigate();

  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  return (
    <div className="cart-page">
      <h1 className="cart-title">🛒 Your Cart</h1>

      {cart.length === 0 ? (
        <p className="cart-empty">Your cart is empty.</p>
      ) : (
        <div>
          <ul className="cart-list">
            {cart.map((item, index) => (
              <li key={index} className="cart-item">
                <div className="cart-item-info">
                  <h6>{item.name}</h6>
                  <small>
                    L{item.price} × {item.qty} ={" "}
                    <strong>L{item.price * item.qty}</strong>
                  </small>
                </div>
                <div className="cart-actions">
                  <button onClick={() => addToCart(item)} className="qty-btn plus">
                    +
                  </button>
                  <button onClick={() => removeFromCart(item.id)} className="qty-btn minus">
                    −
                  </button>
                  <button onClick={() => clearFromCart(item.id)} className="remove-btn">
                    Remove
                  </button>
                </div>
              </li>
            ))}
          </ul>

          <h4 className="cart-total">
            Total: <span>L{total.toFixed(2)}</span>
          </h4>

          <button className="checkout-btn" onClick={() => navigate("/checkout")}>
            Proceed to Checkout
          </button>
        </div>
      )}
    </div>
  );
}

export default Cart;
